/**
 * アコーディオン
 * @see https://ics.media/entry/220901/
 */

import { gsap } from 'gsap';

export default class Accordion {
  constructor() {
    this.arrayElmsAccordion = [...document.querySelectorAll('[data-accordion]')];
    if (!this.arrayElmsAccordion.length) return;
    this.accordionHeaderSelector = '[data-summary]';
    this.accordionBodySelector = '[data-content]';
    this.openedClass = 'is-opened';
  }

  openAnima(elmAccordionBody) {
    return gsap.fromTo(
      elmAccordionBody,
      {
        height: 0,
      },
      {
        height: 'auto',
        duration: 0.4,
        ease: 'power4.out',
        overwrite: true,
      }
    );
  }

  closeAnima(elmAccordionBody, elmAccordionParent) {
    return gsap.to(elmAccordionBody, {
      height: 0,
      duration: 0.4,
      ease: 'power4.out',
      overwrite: true,
      onComplete: () => {
        elmAccordionParent.removeAttribute('open');
      },
    });
  }

  addEvent() {
    this.arrayElmsAccordion.forEach((elmAccordion) => {
      const elmAccorionHeader = elmAccordion.querySelector(this.accordionHeaderSelector);
      const elmAccordionBody = elmAccordion.querySelector(this.accordionBodySelector);
      elmAccorionHeader.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation(); // アコーディオンの中に更にアコーディオンがある場合、イベントのバブリングが発生して子アコーディオンも開くからその対策
        if (elmAccordion.classList.contains(this.openedClass)) {
          elmAccordion.classList.toggle(this.openedClass);
          this.closeAnima(elmAccordionBody, elmAccordion).restart();
        } else {
          elmAccordion.classList.toggle(this.openedClass);
          elmAccordion.setAttribute('open', 'true');
          this.openAnima(elmAccordionBody).restart();
        }
      });
    });
  }

  init() {
    if (!this.arrayElmsAccordion.length) return;
    this.addEvent();
  }
}
